var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb3IdTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 79,
    viewBox: "0 0 700 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17C0.5 12.8579 3.85786 9.5 8 9.5H106.663C108.865 9.5 110.982 8.6451 112.566 7.11541L118.517 1.37114C119.486 0.436008 121.021 0.43601 121.99 1.37114L127.94 7.11541C129.525 8.6451 131.641 9.5 133.844 9.5H692C696.142 9.5 699.5 12.8579 699.5 17V71C699.5 75.1421 696.142 78.5 692 78.5H8.00002C3.85788 78.5 0.5 75.1421 0.5 71V17Z",
    fill: "url(#paint0_linear_10461_78493)",
    fillOpacity: 0.6,
    stroke: "url(#paint1_linear_10461_78493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10461_78493",
    x1: -12.1604,
    y1: 7.50002,
    x2: 697.072,
    y2: 56.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00589031,
    stopColor: "#7A82E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504201,
    stopColor: "#9298EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E92EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10461_78493",
    x1: 0.00000593989,
    y1: 7.99993,
    x2: 692.316,
    y2: 73.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898DC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9197DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3IdTip);
export default __webpack_public_path__ + "static/media/web3id-tip.762290bc1a0295bdc0232c2cd2f50f0e.svg";
export { ForwardRef as ReactComponent };